import axiosInstance from './axiosInstance';

import type { Response } from './axiosInstance'

type PostCalculationParams = {
    type: string;
    path: string;
    comment: string;
    charge: number;
    multiplicity: number;
}

type PostCalculationResponse = {
    job_name: string;
    path: string;
    time: number;
}

export const postCalculation = async (params: PostCalculationParams): Promise<Response<PostCalculationResponse | undefined> | undefined> => {
    try {
        const response = await axiosInstance.post<Response<PostCalculationResponse | undefined>>(`/calculation/start`, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (e) {
        return undefined;
    }
}